<template>
    <div>
        <SearchObject
            :disabled="disabled"
            :value="value"
            @input="$emit('input', $event)"
            @select="$emit('select', $event)"
            :base-url="baseUrl"
            :label="label || $translate('select_receipt')"
            :additional-params="{ ordering: '-receipt_id', ...additionalParams }"
            :item-text="itemText"
            :readonly="readonly"
            :required="required"
            :autofocus="autofocus"
            :hide-details="hideDetails"
            :error-messages="errorMessages"
            ref="search"
            :dense="dense"
            :outlined="outlined"
        >
            <template slot="item" slot-scope="{ item }">
                <div class="d-block py-2">
                    <div class="font-weight-bold">
                        {{ item.receipt_id }} - {{ item.receipt_date }}
                        <template v-if="item.stock_data">
                            - {{ $utils.getStockName(item.stock_data) }}</template
                        >
                    </div>

                    <div>
                        <template
                            v-if="
                                item.owner_data?.name && item.owner != current_entity_id
                            "
                        >
                            {{ item.owner_data.name }} -
                        </template>
                        <template v-if="item.provider_data?.name">
                            {{ item.provider_data.name }} -
                        </template>

                        {{ item.products_count }}
                        {{
                            item.products_count > 1
                                ? $translate("products_count")
                                : $translate("product_count")
                        }}
                        -
                        {{ item.items_count }}
                        {{
                            item.items_count > 1
                                ? $translate("items_count")
                                : $translate("item_count")
                        }}
                    </div>
                </div>
            </template>
        </SearchObject>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "SearchProvider",
    props: {
        // The base URL to fetch items from.
        baseUrl: {
            type: String,
            default: "/api/receipts/",
        },
        // Additional GET parameters to include in the API request.
        additionalParams: {
            type: Object,
            default: () => ({}),
        },
        // Whether the component is disabled.
        disabled: {
            type: Boolean,
            default: false,
        },
        // v-model binding (selected item ID).
        value: {
            type: [String, Number],
            default: null,
        },
        // Label for the autocomplete.
        label: {
            type: String,
            default: "",
        },
        // Optional limit per request.
        limit: {
            type: Number,
            default: 20,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        hideDetails: {
            type: [Boolean, String],
            default: false,
        },
        outlined: { type: Boolean, default: false },
        dense: {
            type: Boolean,
            default: false,
        },
        errorMessages: {
            type: [String, Array],
            default: null,
        },
    },
    methods: {
        itemText(item) {
            let label = `${item.receipt_id} - ${item.receipt_date}`;
            if (item.owner != this.current_entity_id) {
                label += ` - ${item.owner_data.name}`;
            }
            if (item.provider_data?.name) {
                label += ` - ${item.provider_data.name}`;
            }

            label += ` - ${item.products_count} ${
                item.products_count > 1
                    ? this.$translate("products_count")
                    : this.$translate("product_count")
            }`;
            label += ` - ${item.items_count} ${
                item.items_count > 1
                    ? this.$translate("items_count")
                    : this.$translate("item_count")
            }`;

            return label;
        },
        focus() {
            this.$refs.search.focus();
        },
    },
    computed: {
        ...mapGetters("session", ["current_entity_id"]),
    },
    i18n: {
        messages: {
            en: {
                select_receipt: "Select a receipt",
                product_count: "product",
                products_count: "products",
                item_count: "item",
                items_count: "items",
            },
            fr: {
                select_receipt: "Sélectionnez une expédition",
                product_count: "produit",
                products_count: "produits",
                item_count: "elément",
                items_count: "eléments",
            },
        },
    },
};
</script>
